import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  EmailVerificationPushNotification,
  IssuePlatformJwtResponse,
} from '@arc/unified-payments-frontend/shared-payment';

export const PoaPaymentDetailsPaymentLinksApiActions = createActionGroup({
  source: 'POA Payment Details - Payment Links API',
  events: {
    'Sign In Email Sent': props<{ token: string }>(),
    'Sign In Email Error': props<{ error: HttpErrorResponse }>(),
    'Email Verification Received': props<{
      notification: EmailVerificationPushNotification;
    }>(),
    'Email Verification Error': props<{ error: unknown }>(),
    'Platform Jwt Obtained': props<IssuePlatformJwtResponse>(),
    'Platform Jwt Error': props<{ error: HttpErrorResponse }>(),
    'Verify User Is Provisioned Success': emptyProps(),
    'Verify User Is Provisioned Error': props<{ error: HttpErrorResponse }>(),
  },
});
